module.exports = __webpack_public_path__ + "static/media/space-dust-3.8fea6587.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/space-dust-3.png
// module id = 65
// module chunks = 0